import { render, staticRenderFns } from "./VrPage.vue?vue&type=template&id=1e40e11e&"
import script from "./VrPage.vue?vue&type=script&lang=js&"
export * from "./VrPage.vue?vue&type=script&lang=js&"
import style0 from "./VrPage.vue?vue&type=style&index=0&id=1e40e11e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports